/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Helpers to interact with strings / namespace
 * @author Alex Brizius
 */

interface ResolvedResource {
	name: string;
	namespace: string;
	value: string;
}

const namespace = "covidtriage";

export function getString(id: StringResourceId | string): string {
	const name = typeof id === "string" ? id : ((id as any) as ResolvedResource).name;
	return (global as any).$$WP.Strings.getNamespace(namespace).getString(name);
}

export function getKeyedString(srID: StringResourceId, key: string): string {
	const { namespace, name } = (srID as any) as ResolvedResource;
	return (global as any).$$WP.Strings.getNamespace(namespace).getKeyedString(name, key);
}

export function addMnemonic(name: string, value: string): void {
	return (global as any).$$WP.Strings.getNamespace(namespace).addMnemonic(name, value);
}

export function clearMnemonics(): void {
	return (global as any).$$WP.Strings.getNamespace(namespace).clearMnemonics();
}